"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-e0b56e80"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "header-wrapper" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "content-wrapper flex-center-column" }, [
    /*#__PURE__*/ (0, vue_2.createTextVNode)(" 変更が保存されていません。"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("br"),
    /*#__PURE__*/ (0, vue_2.createTextVNode)("このまま続行しますか？ ")
], -1 /* HOISTED */));
const _hoisted_3 = { class: "footer-btn-wrapper" };
const _hoisted_4 = ["disabled"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../Modal.vue"));
const AlertIcon_vue_1 = __importDefault(require("../../view/assets/icons/AlertIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SaveConfirmModal',
    setup(__props, { expose: __expose }) {
        const isVisible = (0, vue_3.ref)(false);
        const isLoading = (0, vue_3.ref)(false);
        const completionDelayMs = (0, vue_3.ref)(0);
        const saveCallback = (0, vue_3.ref)(null);
        const completeCallback = (0, vue_3.ref)(null);
        function openModal(onSave, onComplete, delayMs = 0) {
            saveCallback.value = onSave;
            completeCallback.value = onComplete;
            completionDelayMs.value = delayMs;
            isVisible.value = true;
        }
        function closeModal() {
            isVisible.value = false;
        }
        async function handleComplete(delayMs = 0) {
            isVisible.value = false;
            // Add a delay before completing to show the success snackbar.
            if (delayMs > 0) {
                await new Promise(resolve => setTimeout(resolve, delayMs));
            }
            completeCallback.value?.();
        }
        // Save, then complete the pending action.
        async function handleSaveBtn() {
            if (isLoading.value || !saveCallback.value) {
                return;
            }
            try {
                isLoading.value = true;
                const isSuccess = await saveCallback.value();
                if (!isSuccess) {
                    return;
                }
                await handleComplete(completionDelayMs.value);
            }
            finally {
                isLoading.value = false;
            }
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": isLoading.value,
            };
        });
        __expose({ openModal });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal
                }, {
                    "header-icon": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createVNode)(AlertIcon_vue_1.default)
                        ])
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        _hoisted_2
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-modal-btn oplus-cancel-btn font-sm",
                                onClick: _cache[0] || (_cache[0] = ($event) => (handleComplete())),
                                disabled: isLoading.value
                            }, "変更を破棄", 8 /* PROPS */, _hoisted_4),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn font-sm", loadingClass.value]),
                                onClick: handleSaveBtn
                            }, "保存する", 2 /* CLASS */)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
